<template>
  <div>
    <UserProfile />
  </div>
</template>

<script>
import UserProfile from '../components/userProfile/UserProfile.vue'

export default {
  components: {
    UserProfile,
  },
}
</script>
